var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCrossRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.346443 0.175736C0.577374 -0.0585786 0.951789 -0.0585786 1.18272 0.175736L6 5.06358L10.8173 0.175736C11.0482 -0.0585786 11.4226 -0.0585786 11.6536 0.175736C11.8845 0.41005 11.8845 0.789949 11.6536 1.02426L6.83628 5.91211L11.8268 10.9757C12.0577 11.2101 12.0577 11.5899 11.8268 11.8243C11.5959 12.0586 11.2215 12.0586 10.9905 11.8243L6 6.76064L1.00948 11.8243C0.778545 12.0586 0.404131 12.0586 0.173199 11.8243C-0.0577329 11.5899 -0.0577329 11.2101 0.173199 10.9757L5.16372 5.91211L0.346443 1.02426C0.115511 0.789949 0.115511 0.41005 0.346443 0.175736Z",
    fill: "#F45045"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrossRed);
export default __webpack_public_path__ + "static/media/iconCrossRed.119123a8154db634b06c8785a221231a.svg";
export { ForwardRef as ReactComponent };